import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../../config/firebase";

interface Props {
    children: React.ReactNode;
}

const AuthChecker = ({ children }: Props) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!auth.currentUser) {
            sessionStorage.setItem('originalUrl', location.pathname);
            navigate("/login");
        }
    }, [navigate, location.pathname]);

    return <>{children}</>;
};

export default AuthChecker;
